export interface TenantRecord {
  id: string;
  _id: string;
  name: string;
  slug: string;
  status: string;
  contact: { email: string; phone: string; address?: string };
  settings: { currency: string; dateFormat: string; timezone: string; country: string };
  metadata: { createdAt: string; createdBy: string; updatedAt: string; updatedBy: string };
  registeredName?: string;
  registrationNumber?: string;
  tenantId?: string;
  urn?: string;
  deletedAt?: string;
  suspendedAt?: string;
  suspendedBy?: string;
  suspendedReason?: string;
  reactivatedAt?: string;
  reactivatedBy?: string;
  reactivatedReason?: string;
  liquidatedAt?: string;
  liquidatedBy?: string;
  liquidatedReason?: string;
}

export const STATUS_COLORS: Record<string, 'success' | 'warning' | 'error' | 'default'> = {
  Active: 'success',
  Suspended: 'warning',
  Liquidated: 'default',
};

export const TENANT_STEPS = ['Basic Info', 'Contact', 'Settings', 'Review'] as const;
